export default __webpack_public_path__ + "static/media/mostaza.8223943d.svg";